import { render } from "./Thekedar.vue?vue&type=template&id=72f4a09b&scoped=true"
import script from "./Thekedar.vue?vue&type=script&lang=js"
export * from "./Thekedar.vue?vue&type=script&lang=js"

import "./Thekedar.vue?vue&type=style&index=0&id=72f4a09b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f4a09b"]])

export default __exports__